namespace Ir.Components.Filters.NumericFilter {
    interface INumericFilterViewModel {
        filter: Filter;
        numberBoxSettings: DevExpress.ui.dxNumberBox.Properties;
        numberBoxComponent: DevExpress.ui.dxNumberBox;
        nullButtonParams: Ir.Components.Filters.NullButton.INullButtonParams;
    }

    export function getViewModel(this: INumericFilterViewModel, params: IFilterParameterVM) {
        let self = this;
        this.filter = params.filter;

        this.filter.startDisplayCondition(this.filter.startCondition() === null ? irSettings.nullText : this.filter.startCondition());
        this.numberBoxSettings = {
            disabled: ko.computed(function () {
                return self.filter.readOnly();
            }) as any,
            value: this.filter.startCondition as any,
            showSpinButtons: isMobile() ? false : true,
            showClearButton: true,
            onInitialized(e) {
                self.numberBoxComponent = e.component;
            },
            onInput: function (e) {
                workbook.workbookConfig.workbookHelper.applyFiltersDisabled(false);
            },
            onValueChanged: function (data) {
                if (data.previousValue !== data.value) {
                    self.filter.startCondition(data.value)
                    self.filter.startDisplayCondition(data.value === null ? irSettings.nullText : data.value);
                    self.filter.publish();
                }
            }
        }

        this.filter.clearFilter = function (this: Filter) {
            this.startCondition("")
        };

        this.nullButtonParams = {
            filter: this.filter,
            onItemClick(e) {
                if (self.filter.startCondition() === null) {
                    self.filter.startCondition("0");
                    self.filter.startDisplayCondition("0");
                }
                else {
                    self.filter.startCondition(null);
                    self.filter.startDisplayCondition(irSettings.nullText);
                }

                self.filter.publish();
                self.numberBoxComponent.element().focus();
            }
        };
    }
}